import Button from "./Buttons/Button"
import Text from "./Text"
import { useState } from "react";

function darkenColor(hex, amount = 1) {
    let c = hex.replace("#", "");
    if (c.length === 3) c = c.split("").map((ch) => ch + ch).join("");

    const num = parseInt(c, 16);
    const r = Math.max(0, Math.floor(((num >> 16) & 0xff) * (1 - amount)));
    const g = Math.max(0, Math.floor(((num >> 8) & 0xff) * (1 - amount)));
    const b = Math.max(0, Math.floor((num & 0xff) * (1 - amount)));

    return `#${[r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("")}`;
}

const ItemScrollbar = ({
    itemType = "",
    items,
    onClickAction,
    itemDisplayOption = null,
    colorDisplayOption = null,
    backgroundClasses = "rounded-lg bg-white p-1",
    alwaysColored = false
}) => {

    const [activeIndex, setActiveIndex] = useState(0);

    const handleToggleView = (e, index, item) => {
        e.preventDefault();
        setActiveIndex(index);
        onClickAction(item);
    };

    const ItemButtonField = ({ item, index }) => {
        const isActive = index === activeIndex;
        const showColor = alwaysColored || isActive;
        const baseColor = colorDisplayOption ? colorDisplayOption(item) : null;
        const darkColor = showColor && baseColor ? darkenColor(baseColor, 0.45) : null;

        return (
            <Button
                onClickAction={(e) => handleToggleView(e, index, item)}
                text={itemDisplayOption ? itemDisplayOption(item) : null}
                overflow=""
                buttonColor={showColor ? null : "bg-white"}
                classNames="flex-row p-3 items-center shrink-0"
                borderStyle="border-2 rounded-xl"
                textClasses="whitespace-nowrap"
                style={{
                    backgroundColor: showColor ? baseColor : "transparent",
                    ...(darkColor ? { borderColor: isActive ? darkColor : "transparent", color: darkColor  } : {})
                }}
            />
        )
    }

    return (
        <div className={`w-full flex flex-row gap-1 overflow-x-auto ${backgroundClasses}`}>
            {items.length > 0 ? items.map((item, index) => (
                <ItemButtonField key={item.id || index} item={item} index={index} />
            )) : <Text type="maintitle" classNames={"flex justify-center itemscenter"}>Keine {itemType} vorhanden</Text>
            }
        </div>
    )
}
export default ItemScrollbar